import {
  pxTovW,
  pxToRem,
  IconWrapper,
  IStyles,
  theme,
  PrimaryButton,
  useCommonServiceClientContext,
  deserify,
  getDifficultyLevelString,
  InfoBar,
  ActionsPopup,
  Loader,
  calculateTotalTime,
} from '@geneo2-web/shared-ui';
import { Box, Button, Divider, Typography, useMediaQuery } from '@mui/material';
import {
  useAppDispatch,
  useAppSelector,
} from '../../../../reduxStore/reduxHooks';
import { useEffect, useRef, useState } from 'react';
import {
  ChapterIdsInfo,
  ChapterInfo,
  MarkingSchemeEnum,
  MultiSubjectSection,
  MultiSubjectSectionStatusEnum,
  MultiSubjectSubSection,
  QuestionModuleMap,
  TaskCreationStatusEnum,
  TaskEnum,
  TaskMetaInfo,
} from '@protos/learning_management/lms.db_pb';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  FA_CREATION,
  FA_DRAFT,
  FA_QUESTION_BANK,
  HOME,
} from '../../../../routeHandling/RoutesNomenclature';
import {
  DifficultyLevelEnum,
  Question,
} from '@protos/content_management/content.db_pb';
import { setToastInfoV2 } from '../../../Home/reducer/homeDashboard.slice';
import {
  setFAContent,
  setFAMultiSubjectInfoHash,
  setFASelectedChapters,
  setFASettingsConfig,
} from '../../reducer/assessmentFlow.slice';
import {
  CourseIndexInfo,
  SubjectChapterMiniInfo,
  TopicBasicInfo,
} from '@protos/content_management/content.common.apis_pb';
import {
  getBloomLevelData,
  getStringHash,
  questionCountTypeWise,
} from '../../QuestionPaperGenerator/ReviewQuestionPaper/utils';
import {
  getChapterInfoFromSelectedSectionQuestions,
  getLatestQuestionModuleMap,
} from '../FAv2.utils';
import { ConnectError } from '@bufbuild/connect';
import { BloomLevelComponent } from '../../components/BloomLevelComponent';
import { InfoBarComponent } from '../../components/InfoBarComp';
import { ChapterTopicPopup } from '../../../../components/ChapterTopicPopup';
import { useGlobalContext } from '../../../../app/Context/GlobalContextProvider';
import { ProfileRolesEnum } from '@protos/user_management/ums.db_pb';
import { buildTaskInfoModels } from '../../QuestionPaperGeneratorV2/QPGv2.utils';
import { SelectedChaptersV2 } from '../../QuestionPaperGeneratorV2/components/SelectedChaptersV2';
import { FAReviewSection } from './components/FAReviewSection';
import { AddFromQuestionBank } from './components/AddFromQuestionBank';

const styles: IStyles = {
  root: {
    paddingX: { xs: pxToRem(20), md: pxTovW(50), lg: pxTovW(240) },
    paddingY: { xs: pxToRem(20), md: pxTovW(50) },
    backgroundColor: '#f8f7fc',
    minHeight: '100vh',
  },
  primaryHeadingBox: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  mainContainer: {
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    gap: { xs: pxToRem(20), md: pxTovW(40) },
    marginTop: { xs: pxToRem(20), md: pxTovW(40) },
  },
  leftPanel: {
    display: 'flex',
    flexDirection: 'column',
    gap: { xs: pxToRem(10), md: pxTovW(30) },
    flexBasis: { md: pxTovW(550), lg: pxTovW(415) },
  },
  bloomContainer: {
    border: '1px solid #E0E2E4',
    display: { xs: 'none', md: 'flex' },
    flexDirection: 'column',
    gap: { xs: pxToRem(11), md: pxTovW(20) },
    padding: {
      xs: pxToRem(10),
      md: `${pxTovW(15)} ${pxTovW(13)} ${pxTovW(15)} ${pxTovW(10)}`,
    },
    background: '#FFFFFF',
    boxShadow: `0px 0px ${pxToRem(5)} #E7E7E7D9`,
    borderRadius: { xs: pxToRem(10), md: pxTovW(15) },
  },
  paperDetailsBox: {
    display: 'flex',
    justifyContent: 'space-between',
    background: '#FFFFFF',
    boxShadow: `0px 0px ${pxToRem(5)} #E7E7E7D9`,
    borderRadius: { xs: pxToRem(10), md: pxTovW(15) },
    paddingX: { xs: pxToRem(10), md: pxTovW(20) },
    paddingY: { xs: pxToRem(10), md: pxTovW(25) },
  },
  detailsBox: {
    display: 'flex',
    alignItems: 'center',
    gap: { xs: pxToRem(5), md: pxTovW(5) },
  },
  mobileContainer: {
    display: { xs: 'flex', md: 'none' },
    border: '1px solid #007CDC4D',
    flexDirection: 'row',
    gap: { xs: pxToRem(5), md: pxTovW(5) },
    padding: { xs: pxToRem(10), md: pxTovW(15) },
    marginY: { xs: pxToRem(10), md: pxTovW(10) },
    // marginX: { xs: pxToRem(20) },
    background: '#FFFFFF',
    boxShadow: `0px 0px ${pxToRem(5)} #E7E7E7D9`,
    borderRadius: { xs: pxToRem(10), md: pxTovW(15) },
    justifyContent: 'space-between',
  },

  secondaryHeadingBox: {
    // display: 'flex',
    // justifyContent: 'space-between',
    // alignItems: 'center',
    marginBottom: { xs: pxToRem(20), md: pxTovW(40) },
  },
  previewAndPublishBox: {
    display: 'flex',
    alignItems: 'center',
    gap: { xs: pxToRem(10), md: pxTovW(30) },
  },
  addMoreBox: {
    background: '#C1F8DA',
    display: 'flex',
    borderRadius: { xs: pxToRem(6), md: pxTovW(10) },
    boxSizing: 'border-box',
    justifyContent: 'center',
    alignItems: 'center',
    border: '1px solid #0AA34F',
    padding: {
      xs: pxToRem(5),
      md: `${pxTovW(16)} ${pxTovW(23)}`,
      lg: `${pxTovW(13)} ${pxTovW(25)}`,
    },
    gap: { xs: pxToRem(5), md: pxTovW(16) },
    // height: { xs: pxToRem(32), md: pxTovW(57) },
  },
  addInstructionsBox: {
    background: '#CFEAFF',
    display: 'flex',
    borderRadius: { xs: pxToRem(6), md: pxTovW(10) },
    boxSizing: 'border-box',
    justifyContent: 'center',
    alignItems: 'center',
    border: '1px solid #007CDC',
    padding: {
      xs: pxToRem(5),
      md: `${pxTovW(16)} ${pxTovW(23)}`,
      lg: `${pxTovW(13)} ${pxTovW(25)}`,
    },
    gap: { xs: pxToRem(5), md: pxTovW(16) },
    // height: { xs: pxToRem(32), md: pxTovW(57) },
  },
  generalInstructionsBox: {
    display: 'flex',
    flexDirection: 'column',
    gap: { xs: pxToRem(10), md: pxTovW(10) },
    backgroundColor: '#ffffff',
    border: '1px solid #E0E2E4',
    borderRadius: { xs: pxToRem(15), md: pxTovW(15) },
    paddingX: { xs: pxToRem(20), md: pxTovW(20) },
    paddingY: { xs: pxToRem(16), md: pxTovW(16) },
    marginTop: { xs: pxToRem(20), md: pxTovW(25) },
    marginBottom: { xs: pxToRem(30), md: pxTovW(70) },
  },
  subjectDataBox: {
    display: 'flex',
    flexDirection: 'column',
    gap: { xs: pxToRem(10), md: pxTovW(40) },
  },
  subjectSectionDetails: {
    backgroundColor: '#ffffff',
    borderRadius: { xs: pxToRem(15), md: pxTovW(15) },
    border: '1px solid #E0E2E4',
    paddingX: { xs: pxToRem(20), md: pxTovW(20) },
    paddingY: { xs: pxToRem(16), md: pxTovW(16) },
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  instructionText: {
    fontFamily: 'Poppins',
    marginTop: { xs: pxToRem(15), md: pxTovW(15) },
    marginBottom: { xs: pxToRem(40), md: pxTovW(40) },
    fontSize: { xs: pxToRem(12), md: 'unset' },
  },
};

export const FAReview = () => {
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isIpad = useMediaQuery(theme.breakpoints.down('lg'));
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { setSelectedFunction, setSelectedLogoClickHandler } =
    useGlobalContext();

  const {
    LmsAssessmentTeacherAPIServiceV6WithStatusCodeHandler,
    LmsAssessmentCommonAPIServiceV1ClientWithStatusCodeHandler,
  } = useCommonServiceClientContext();
  const { user_info } = deserify(useAppSelector((state) => state.auth));
  const {
    fa_content,
    fa_selected_section_number,
    fa_selected_chapters,
    fa_settings_config,
    fa_created_section_test,
    fa_multi_subject_info_hash,
  } = deserify(useAppSelector((state) => state.assessment));

  const selectedSection = fa_content?.multiSubjectSections?.find(
    (s) => s.sectionNo === fa_selected_section_number
  );
  const selectedSectionIndex = (() => {
    const idx = fa_content?.multiSubjectSections?.findIndex(
      (s) => s.sectionNo === fa_selected_section_number
    );
    return idx !== undefined && idx >= 0 ? idx : 0;
  })();

  const [loading, setLoading] = useState<'loading' | 'success' | 'error'>(
    'success'
  );
  const [bloomPopup, setBloomPopup] = useState(false);
  const [chaptersPopup, setChaptersPopup] = useState(false);
  const [assessmentCreationFlow, setAssessmentCreationFlow] = useState<
    'chapter' | 'bloom' | undefined
  >(undefined);
  const [isPaperInitialised, setIsPaperInitialised] = useState(
    !!location.state?.isFromQuestionBank
  );
  const [exitConfirmPopup, setExitConfirmPopup] = useState<
    'back' | 'home' | undefined
  >(undefined);

  const [updatingAssessment, setUpdatingAssessment] = useState(false);
  const isSavingFromEditFlowRef = useRef(false);

  const assessmentQuestionIds =
    selectedSection?.multiSubjectSubSections?.flatMap((subSection) =>
      subSection.subSectionMetaData?.map((meta) => meta.questionId)
    ) ?? [];

  const isAssessmentChanged =
    selectedSection !== undefined &&
    fa_multi_subject_info_hash !== generateHashString(selectedSection);

  const faAssessmentQuestions = (
    fa_content?.assessmentContent?.map((ques) => new Question(ques)) || []
  ).filter((ques) => assessmentQuestionIds.includes(ques.questionId ?? ''));

  const taskMetaInfo = fa_content?.assessment?.taskMetaInfo;
  const sectionChapterInfo = selectedSection?.chapterInfo;
  const filteredTaskMetaInfo = (() => {
    if (
      !taskMetaInfo?.chapterInfo?.chapterTopicsInfo?.length ||
      !sectionChapterInfo?.chapterTopicsInfo?.length
    ) {
      return taskMetaInfo;
    }
    const sectionChapters = sectionChapterInfo.chapterTopicsInfo;
    const allowedChapterIds = new Set(sectionChapters.map((c) => c.chapterId));
    const allowedTopicIdsByChapter = new Map<number, Set<number>>();
    for (const ch of sectionChapters) {
      const topicIds = new Set((ch.topicInfo ?? []).map((t) => t.topicId));
      allowedTopicIdsByChapter.set(ch.chapterId, topicIds);
    }
    const filteredChapterTopicsInfo = taskMetaInfo
      .chapterInfo!.chapterTopicsInfo.filter((ch) =>
        allowedChapterIds.has(ch.chapterId)
      )
      .map(
        (ch) =>
          new ChapterIdsInfo({
            chapterId: ch.chapterId,
            name: ch.name,
            chapterNo: ch.chapterNo,
            noOfQuestions: ch.noOfQuestions,
            subjectId: ch.subjectId,
            topicInfo: (ch.topicInfo ?? []).filter((t) =>
              allowedTopicIdsByChapter.get(ch.chapterId)?.has(t.topicId)
            ),
          })
      );
    return new TaskMetaInfo({
      chapterInfo: new ChapterInfo({
        chapterTopicsInfo: filteredChapterTopicsInfo,
      }),
    });
  })();

  const questionModuleMap =
    fa_content?.questionsSequenceInfo?.questionModuleMap || [];

  const filteredQuestionModuleMap = assessmentQuestionIds.map((qId) => {
    return (
      questionModuleMap.find((val) => val.questionId === qId) ||
      new QuestionModuleMap({
        questionId: qId,
      })
    );
  });

  const totalTimeInMinutes = calculateTotalTime(faAssessmentQuestions || []);

  // --------------------------------------------------------------

  const getMarksForQuestionId = (questionId: string): number => {
    const taskQuestionInfo =
      ((fa_content as any)?.taskQuestionInfo as
        | { questionId?: string; maxMarks?: number }[]
        | undefined) ?? fa_content?.questionsSequenceInfo?.taskQuestionInfo;

    const taskInfo = taskQuestionInfo?.find(
      (info) => info.questionId == questionId
    );
    return typeof taskInfo?.maxMarks === 'number' ? taskInfo.maxMarks : 0;
  };

  // --------------------------------------------------------------

  const sectionToShow =
    selectedSection ?? fa_content?.multiSubjectSections?.[0];

  const selectedSectionTotalQuestions =
    sectionToShow?.multiSubjectSubSections?.reduce(
      (sum, subSection) => sum + (subSection.subSectionMetaData?.length ?? 0),
      0
    ) ?? 0;

  const getTotalMarksForSection = () => {
    const section = fa_content?.multiSubjectSections?.find(
      (s) => s.sectionNo === fa_selected_section_number
    );

    return (
      section?.multiSubjectSubSections?.reduce(
        (sectionSum, subSection) =>
          sectionSum +
          (subSection.subSectionMetaData?.reduce(
            (subSum, entry) =>
              subSum +
              (entry.maxMarks > 0
                ? entry.maxMarks
                : getMarksForQuestionId(entry.questionId)),
            0
          ) ?? 0),
        0
      ) ?? 0
    );
  };

  // --------------------------------------------------------------

  const fetchAssessmentContent = async () => {
    try {
      setLoading('loading');
      const fetchAssessmentContentResponse =
        await LmsAssessmentCommonAPIServiceV1ClientWithStatusCodeHandler.fetchAssessmentContent(
          {
            personId: user_info?.teacherProfileId,
            personType: ProfileRolesEnum.PROFILE_ROLE_TEACHER,
            assessmentId: Number(fa_content?.assessment?.assessmentId),
          }
        );

      if (fetchAssessmentContentResponse.data) {
        setLoading('success');

        dispatch(setFAContent(fetchAssessmentContentResponse.data));
        dispatch(
          setFAMultiSubjectInfoHash(
            generateHashString(
              fetchAssessmentContentResponse.data?.multiSubjectSections?.find(
                (s) => s.sectionNo === fa_selected_section_number
              )
            )
          )
        );
        setIsPaperInitialised(true);
      } else {
        setLoading('error');
      }
    } catch (error) {
      console.log(error);
      setLoading('error');
    }
  };

  // --------------------------------------------------------------

  const handleCreateAssessment = async () => {
    await handleSave({ createAssessment: true });
  };

  // --------------------------------------------------------------

  // const bloomLevelData = getBloomLevelData(
  //   questionsListWithoutAlternateQuestions
  // );
  const bloomLevelData = getBloomLevelData(faAssessmentQuestions);

  // --------------------------------------------------------------

  interface IDifficultyLevelBreakdown {
    easy: {
      difficultyLevel: DifficultyLevelEnum.DIFFICULTY_LEVEL_LOW;
      count: number;
    };
    medium: {
      difficultyLevel: DifficultyLevelEnum.DIFFICULTY_LEVEL_MEDIUM;
      count: number;
    };
    hard: {
      difficultyLevel: DifficultyLevelEnum.DIFFICULTY_LEVEL_HIGH;
      count: number;
    };
  }

  const getDifficultyLevelBreakdown = (
    questionModuleMap: QuestionModuleMap[]
  ) => {
    const difficultyLevelBreakdown: IDifficultyLevelBreakdown = {
      easy: {
        difficultyLevel: DifficultyLevelEnum.DIFFICULTY_LEVEL_LOW,
        count: 0,
      },
      medium: {
        difficultyLevel: DifficultyLevelEnum.DIFFICULTY_LEVEL_MEDIUM,
        count: 0,
      },
      hard: {
        difficultyLevel: DifficultyLevelEnum.DIFFICULTY_LEVEL_HIGH,
        count: 0,
      },
    };
    filteredQuestionModuleMap.forEach((questionModule) => {
      const difficultyLevel = questionModule.difficultyLevel;
      switch (difficultyLevel) {
        case DifficultyLevelEnum.DIFFICULTY_LEVEL_LOW:
          ++difficultyLevelBreakdown.easy.count;
          break;
        case DifficultyLevelEnum.DIFFICULTY_LEVEL_MEDIUM:
          ++difficultyLevelBreakdown.medium.count;
          break;
        case DifficultyLevelEnum.DIFFICULTY_LEVEL_HIGH:
          ++difficultyLevelBreakdown.hard.count;
          break;
        default:
          break;
      }
    });
    return difficultyLevelBreakdown;
  };

  // --------------------------------------------------------------

  const infoBarContentList = [
    {
      iconName: 'questions',
      // heading: totalQuestionsCount,
      heading: faAssessmentQuestions?.length || 0,
      subHeading: 'Questions',
    },
    {
      iconName: 'clock',
      heading: `${totalTimeInMinutes}`,
      subHeading: 'Minutes',
    },
    {
      iconName: 'level',
      heading: `${getDifficultyLevelString(
        selectedSection?.avgDifficultyLevel
      )}`,
      subHeading: 'Difficulty Level',
    },
  ];

  // --------------------------------------------------------------

  const getDifficultyLevelStats = () => {
    const breakdown = getDifficultyLevelBreakdown(filteredQuestionModuleMap);
    return [
      {
        iconName: 'stat-green',
        heading: breakdown.easy.count,
        headingSubText: 'Qs',
        subHeading: 'Easy',
      },
      {
        iconName: 'stat-yellow',
        heading: breakdown.medium.count,
        headingSubText: 'Qs',
        subHeading: 'Medium',
      },
      {
        iconName: 'stat-red',
        heading: breakdown.hard.count,
        headingSubText: 'Qs',
        subHeading: 'Hard',
      },
    ];
  };

  // --------------------------------------------------------------

  const handleSave = async (props: {
    createAssessment?: boolean;
    editAssessmentCreationFlow?: 'chapter' | 'bloom';
  }) => {
    const { createAssessment, editAssessmentCreationFlow } = props;
    try {
      setLoading('loading');
      setUpdatingAssessment(true);

      const multiSubjectSectionMetaInfo =
        fa_content?.multiSubjectSections?.find(
          (section) => section.sectionNo === fa_selected_section_number
        );

      const chapterInfoForCreateAssessment =
        getChapterInfoFromSelectedSectionQuestions({
          section: multiSubjectSectionMetaInfo,
          questionModuleMap,
          chapterTopicsInfo: taskMetaInfo?.chapterInfo?.chapterTopicsInfo ?? [],
        });

      const metaInfo: MultiSubjectSection[] =
        fa_content?.multiSubjectSections?.map(
          (section: MultiSubjectSection) => {
            const isSelectedSection =
              section.sectionNo === fa_selected_section_number;

            if (!isSelectedSection) return section;

            const sectionPayload =
              editAssessmentCreationFlow && multiSubjectSectionMetaInfo
                ? {
                    ...multiSubjectSectionMetaInfo,
                    multiSubjectSectionStatus:
                      MultiSubjectSectionStatusEnum.MULTI_SUBJECT_SECTION_STATUS_INITIALIZED,
                    multiSubjectSubSections: (
                      multiSubjectSectionMetaInfo.multiSubjectSubSections ?? []
                    ).map(
                      (subSection) =>
                        new MultiSubjectSubSection({
                          ...subSection,
                          subSectionMetaData: [],
                        })
                    ),
                  }
                : {
                    ...multiSubjectSectionMetaInfo,
                    multiSubjectSectionStatus: editAssessmentCreationFlow
                      ? MultiSubjectSectionStatusEnum.MULTI_SUBJECT_SECTION_STATUS_INITIALIZED
                      : createAssessment
                      ? MultiSubjectSectionStatusEnum.MULTI_SUBJECT_SECTION_STATUS_APPROVED
                      : section.multiSubjectSectionStatus ??
                        MultiSubjectSectionStatusEnum.MULTI_SUBJECT_SECTION_STATUS_DRAFT,
                    // chapterInfo: createAssessment
                    //   ? chapterInfoForCreateAssessment
                    //   : section.chapterInfo,
                    chapterInfo: chapterInfoForCreateAssessment,
                  };

            return new MultiSubjectSection({
              ...sectionPayload,
              numberOfQuestion: section.multiSubjectSubSections.reduce(
                (sum, subSection) =>
                  sum + (subSection.subSectionMetaData?.length ?? 0),
                0
              ),
              totalMarks: getTotalMarksForSection(),
            });
          }
        ) ?? [];

      const filteredQuestionModuleMap = getLatestQuestionModuleMap({
        metaInfo: metaInfo,
        questionModuleMap: fa_content?.questionsSequenceInfo?.questionModuleMap,
      });
      // : fa_content?.multiSubjectSections || [];

      const assessmentCreationSubmitResponse =
        await LmsAssessmentTeacherAPIServiceV6WithStatusCodeHandler.assessmentCreationSubmit(
          {
            teacherId: user_info?.teacherProfileId,
            assessmentId: fa_content?.assessment?.assessmentId,
            classId: fa_content?.assessment?.classId,
            creationStatus: TaskCreationStatusEnum.TASK_CREATION_STATUS_DRAFT,
            multiSubjectSectionMetaInfo: metaInfo,
            sectionId: fa_content?.assessment?.sectionId,
            subjectIds:
              fa_content?.multiSubjectSections.map(
                (section) => section.subjectId
              ) ?? [],
            taskName: fa_content?.assessment?.assessmentTitle,
            // taskType: fa_content?.assessment?.taskType,
            taskType: TaskEnum.TASK_MULTI_SUBJECT_FORMATIVE_ASSESSMENT_CUSTOM,
            instructions: fa_content?.assessment?.assessmentInstructions,
            questionModuleMap: filteredQuestionModuleMap,
            selectedTasksInfo: buildTaskInfoModels(metaInfo),
            chapterIdsInfo: taskMetaInfo?.chapterInfo?.chapterTopicsInfo,
          }
        );

      if (assessmentCreationSubmitResponse.status === 200) {
        if (createAssessment) {
          navigate(
            `${FA_DRAFT}?assessment_id=${assessmentCreationSubmitResponse.data?.assessment?.assessmentId}`
          );
          return;
        } else if (editAssessmentCreationFlow) {
          // // Before navigate: if fa_selected_chapters is missing, set it from the correct section's chapterInfo in fa_content
          // if (
          //   (!fa_selected_chapters || !fa_selected_chapters.chapters?.length) &&
          //   multiSubjectSectionMetaInfo?.chapterInfo?.chapterTopicsInfo?.length
          // ) {
          //   const sectionChapterInfo =
          //     multiSubjectSectionMetaInfo.chapterInfo.chapterTopicsInfo;
          //   const chaptersFromSection: SubjectChapterMiniInfo[] =
          //     sectionChapterInfo.map(
          //       (ch) =>
          //         new SubjectChapterMiniInfo({
          //           chapterId: ch.chapterId,
          //           chapterNo: ch.chapterNo,
          //           chapterTitle: ch.name,
          //           posterImagesUrl: '',
          //           noOfTopics: ch.topicInfo?.length ?? 0,
          //           topics: (ch.topicInfo ?? []).map(
          //             (t) =>
          //               new TopicBasicInfo({
          //                 topicId: t.topicId,
          //                 topicNo: t.topicNo,
          //                 topicTitle: t.name,
          //                 posterImagesUrl: '',
          //               })
          //           ),
          //         })
          //     );
          //   dispatch(
          //     setFASelectedChapters(
          //       new CourseIndexInfo({
          //         subjectId: multiSubjectSectionMetaInfo.subjectId,
          //         subjectName: fa_selected_chapters?.subjectName ?? '',
          //         posterImageUrl: fa_selected_chapters?.posterImageUrl ?? '',
          //         chapters: chaptersFromSection,
          //       })
          //     )
          //   );
          // }

          navigate(FA_CREATION + `?edit_flow=${editAssessmentCreationFlow}`);
        }
      }
      fetchAssessmentContent();
      dispatch(
        setFAMultiSubjectInfoHash(
          generateHashString(metaInfo[selectedSectionIndex])
        )
      );
    } catch (error) {
      setLoading('error');
      console.error('Error saving question paper:', error);
      dispatch(
        setToastInfoV2({
          label:
            error instanceof ConnectError
              ? error.rawMessage?.replace(/.*\]\s*/, '').trim()
              : 'Error while saving assessment',
          variant: 'error',
          open: true,
        })
      );
    } finally {
      setUpdatingAssessment(false);
      setLoading('success');
      // if (shouldPublish) {
      //   setBloomPopup(false);
      //   setChaptersPopup(false);
      // }
    }
  };

  // --------------------------------------------------------------

  const renderQuestionTypeList = () => {
    return Object.keys(
      // questionCountTypeWise(questionsListWithoutAlternateQuestions)
      questionCountTypeWise(faAssessmentQuestions)
    ).map((val, index) => (
      <Box
        key={index}
        sx={{
          display: 'flex',
          gap: { xs: pxToRem(5), md: pxTovW(5) },
        }}
      >
        <IconWrapper
          name="question-blue"
          type="png"
          parentFolder="icons"
          size="md"
        />
        <Typography variant="h5">{val}</Typography>
      </Box>
    ));
  };

  // --------------------------------------------------------------

  useEffect(() => {
    if (isSavingFromEditFlowRef.current) return;
    if (
      isPaperInitialised &&
      isAssessmentChanged &&
      fa_multi_subject_info_hash !== undefined
    ) {
      // Update the assessment with the new changes
      handleSave({});
    }
  }, [isAssessmentChanged]);

  const backButtonClick = () => {
    setExitConfirmPopup('back');
  };
  const handleLogoClick = () => {
    setExitConfirmPopup('home');
  };

  useEffect(() => {
    setSelectedFunction(() => backButtonClick);
    setSelectedLogoClickHandler(() => handleLogoClick);
    return () => {
      setSelectedFunction(null);
      setSelectedLogoClickHandler(null);
    };
  }, [exitConfirmPopup]);

  useEffect(() => {
    if (!location.state?.isFromQuestionBank) {
      fetchAssessmentContent();
    } else {
      navigate(location.pathname, {
        replace: true,
        state: {
          isFromQuestionBank: false,
          redirectionPath: location.state?.redirectionPath,
        },
      });
    }
  }, []);

  // --------------------------------------------------------------

  if (loading === 'loading') return <Loader />;

  return (
    <Box sx={styles.root}>
      <Box sx={styles.primaryHeadingBox}>
        <Typography variant="h1">Formative Assessment</Typography>

        <PrimaryButton
          onClick={handleCreateAssessment}
          sx={{ width: 'max-content' }}
        >
          <Typography variant="h3" fontWeight="bold" color="common.white">
            CREATE ASSESSMENT
          </Typography>
        </PrimaryButton>
      </Box>

      <Box sx={styles.mainContainer}>
        {/* LEFT PANEL */}
        <Box sx={styles.leftPanel}>
          <AddFromQuestionBank
            onClick={async () => {
              navigate(FA_QUESTION_BANK, {
                replace: true,
                state: {
                  from: location.pathname,
                  redirectionPath: location.state?.redirectionPath,
                },
              });

              // await interactionEvent({
              //   context: 'Navigation_bar',
              //   name: 'ADD_FROM_QUESTION_BANK',
              //   pathSegments: pathSegments,
              //   isOffline: isOffline,
              // });
            }}
          />

          <Box>
            <Box sx={{ width: '100%', display: { xs: 'none', md: 'flex' } }}>
              <SelectedChaptersV2
                assessmentTaskInfo={filteredTaskMetaInfo}
                questionModuleMap={filteredQuestionModuleMap}
                currentSectionChapterInfo={sectionToShow?.chapterInfo}
                editClickHandler={() => {
                  setAssessmentCreationFlow('chapter');
                }}
              />
            </Box>

            <Box sx={styles.mobileContainer}>
              <Typography
                variant={isMobile ? 'h2' : 'h3'}
                fontWeight="bold"
                fontFamily="poppins"
              >
                What's Covered
              </Typography>
              <IconWrapper
                name="view"
                type="png"
                parentFolder="icons"
                size="md"
                customSx={{
                  height: { xs: pxToRem(20) },
                  width: { xs: pxToRem(20) },
                  cursor: 'pointer',
                }}
                onClick={() => setChaptersPopup(true)}
              />
            </Box>

            <Box sx={styles.mobileContainer}>
              <Typography
                variant={isMobile ? 'h2' : 'h3'}
                fontWeight="bold"
                fontFamily="poppins"
              >
                {selectedSection?.markingSchemeType ===
                MarkingSchemeEnum.MARKING_SCHEME_JEE
                  ? 'Question Type'
                  : 'Bloom Level & Question Type'}
              </Typography>
              <Box
                sx={{
                  display: { xs: 'flex', md: 'none' },
                  gap: { xs: pxToRem(10) },
                }}
              >
                <IconWrapper
                  name="view"
                  type="png"
                  parentFolder="icons"
                  size="large"
                  customSx={{
                    height: { xs: pxToRem(20) },
                    width: { xs: pxToRem(20) },
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    setBloomPopup(true);
                  }}
                />
              </Box>
            </Box>
          </Box>

          <Box sx={styles.bloomContainer}>
            {selectedSection?.markingSchemeType ===
            MarkingSchemeEnum.MARKING_SCHEME_JEE ? (
              <Button
                sx={{ p: '0', width: 'max-content', marginLeft: 'auto' }}
                onClick={() => {
                  setAssessmentCreationFlow('bloom');
                }}
              >
                <IconWrapper
                  name="edit"
                  type="png"
                  parentFolder="icons"
                  size="large"
                />
              </Button>
            ) : (
              <Box>
                <BloomLevelComponent
                  bloomLevelData={bloomLevelData}
                  editClickHandler={() => {
                    setAssessmentCreationFlow('bloom');
                  }}
                />
              </Box>
            )}

            <Divider sx={{ bgcolor: '#E0E0E0', height: '1px', opacity: 0.5 }} />

            <Box sx={{ display: { xs: 'none', md: 'block' } }}>
              <InfoBarComponent contentList={infoBarContentList} />
            </Box>

            {selectedSection?.markingSchemeType ===
              MarkingSchemeEnum.MARKING_SCHEME_GENEO ||
            selectedSection?.markingSchemeType ===
              MarkingSchemeEnum.MARKING_SCHEME_JEE ? (
              <Box>
                <Divider
                  sx={{ bgcolor: '#E0E0E0', height: '1px', opacity: 0.5 }}
                />
                <MarkingScheme
                  markingScheme={selectedSection?.markingSchemeType}
                />
              </Box>
            ) : null}

            <Divider sx={{ bgcolor: '#E0E0E0', height: '1px', opacity: 0.5 }} />

            <Box sx={{ display: { xs: 'none', md: 'block' } }}>
              <Typography
                variant="h3"
                fontWeight={600}
                fontFamily={'poppins'}
                marginBottom={pxToRem(10)}
              >
                Breakdown of Difficulty Level
              </Typography>
              <InfoBarComponent contentList={getDifficultyLevelStats()} />
            </Box>
            <Divider sx={{ bgcolor: '#E0E0E0', height: '1px', opacity: 0.5 }} />
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: { md: pxTovW(20) },
              }}
            >
              <Typography variant="h4" fontWeight={600} fontFamily={'poppins'}>
                Question Type
              </Typography>
              <Box
                sx={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: { xs: pxToRem(20) },
                }}
              >
                {renderQuestionTypeList()}
              </Box>
            </Box>
          </Box>

          <Box sx={styles.paperDetailsBox}>
            <Box sx={styles.detailsBox}>
              <IconWrapper
                name="questions"
                size="md"
                type="png"
                parentFolder="icons"
              />
              <Typography variant="h4">
                No. of Questions:
                <b> {selectedSectionTotalQuestions ?? 0}</b>
              </Typography>
            </Box>

            <Divider
              orientation="vertical"
              sx={{ width: '1px', height: '100%', backgroundColor: '#E0DFDE' }}
            />

            <Box sx={styles.detailsBox}>
              <IconWrapper
                name="percentage-primary"
                size="md"
                type="png"
                parentFolder="icons"
              />
              <Typography variant="h4">
                Total Marks:<b> {getTotalMarksForSection() ?? 0}</b>
              </Typography>
            </Box>
          </Box>
        </Box>

        {/* RIGHT PANEL */}
        <Box sx={styles.rightPanel}>
          <Box sx={styles.secondaryHeadingBox}>
            <Typography variant="h2">Review Questions</Typography>
            <Typography
              sx={{ fontSize: { xs: pxToRem(14), md: pxTovW(24) } }}
              color="text.disabled"
            >
              Replace, Re-order, or Remove
            </Typography>
          </Box>

          <FAReviewSection
            setUpdatingAssessment={setUpdatingAssessment}
            handleSave={handleSave}
          />
        </Box>
      </Box>

      <ChapterTopicPopup
        open={chaptersPopup}
        handleClose={() => {
          setChaptersPopup(false);
        }}
        popupBody={
          <SelectedChaptersV2
            assessmentTaskInfo={filteredTaskMetaInfo}
            questionModuleMap={filteredQuestionModuleMap}
            currentSectionChapterInfo={sectionToShow?.chapterInfo}
            editClickHandler={() => {
              setAssessmentCreationFlow('chapter');
            }}
          />
        }
      />

      <ChapterTopicPopup
        open={bloomPopup}
        handleClose={() => {
          setBloomPopup(false);
        }}
        popupBody={
          <Box
            sx={{
              ...styles.bloomContainer,
              display: { xs: 'flex', md: 'none' },
            }}
          >
            {selectedSection?.markingSchemeType ===
            MarkingSchemeEnum.MARKING_SCHEME_JEE ? null : (
              <Box>
                <BloomLevelComponent
                  bloomLevelData={bloomLevelData}
                  editClickHandler={() => {
                    setAssessmentCreationFlow('bloom');
                  }}
                />
              </Box>
            )}
            <Box>
              <InfoBar contentList={infoBarContentList} />
            </Box>

            {selectedSection?.markingSchemeType ===
              MarkingSchemeEnum.MARKING_SCHEME_GENEO ||
            selectedSection?.markingSchemeType ===
              MarkingSchemeEnum.MARKING_SCHEME_JEE ? (
              <MarkingScheme
                markingScheme={selectedSection?.markingSchemeType}
              />
            ) : null}

            <Box>
              <Typography
                variant="h3"
                fontWeight={600}
                fontFamily={'poppins'}
                marginBottom={pxToRem(10)}
              >
                Breakdown of Difficulty Level
              </Typography>
              <InfoBar contentList={getDifficultyLevelStats()} />
            </Box>

            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                marginY: { xs: pxToRem(10) },
                gap: { xs: pxToRem(10) },
              }}
            >
              <Typography variant="h3" fontWeight={600} fontFamily={'poppins'}>
                Question Type
              </Typography>
              <Box
                sx={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: { xs: pxToRem(12) },
                }}
              >
                {renderQuestionTypeList()}
              </Box>
            </Box>
          </Box>
        }
      />

      <ActionsPopup
        open={!!assessmentCreationFlow}
        handleClose={() => {
          setAssessmentCreationFlow(undefined);
        }}
        fontSmall
        iconName="error_yellow"
        popupText="On editing this, Questions list will be reset."
        splitText="Are you sure?"
        yesClickHandler={async () => {
          isSavingFromEditFlowRef.current = true;
          await handleSave({
            editAssessmentCreationFlow: assessmentCreationFlow,
          });
          isSavingFromEditFlowRef.current = false;
          setAssessmentCreationFlow(undefined);
        }}
        noClickHandler={async () => {
          setAssessmentCreationFlow(undefined);
        }}
      />

      <ActionsPopup
        open={!!exitConfirmPopup}
        handleClose={() => {
          setExitConfirmPopup(undefined);
        }}
        fontSmall
        iconName="error_yellow"
        popupText="Your changes will be saved as draft"
        splitText="Are you sure you want leave?"
        yesClickHandler={async () => {
          if (exitConfirmPopup === 'back') {
            navigate(
              FA_DRAFT +
                `?assessment_id=${fa_content?.assessment?.assessmentId}`
            );
          } else {
            navigate(HOME);
          }
          setExitConfirmPopup(undefined);
        }}
        noClickHandler={async () => {
          setExitConfirmPopup(undefined);
        }}
      />
    </Box>
  );
};

// =====================================================

const generateHashString = (multiSubjectSectionInfo?: MultiSubjectSection) => {
  return getStringHash(
    new MultiSubjectSection(multiSubjectSectionInfo).toJsonString()
  );
};

// =====================================================

const MarkingScheme = (props: { markingScheme: MarkingSchemeEnum }) => {
  const { markingScheme } = props;

  return (
    <Box
      sx={{
        marginTop: { xs: pxToRem(0), md: pxTovW(20) },
        background: '#FFFFFF',
        boxShadow: { xs: `0px 0px ${pxToRem(5)} #E7E7E7D9`, md: 'unset' },
        borderRadius: { xs: pxToRem(10), md: pxTovW(15) },
        paddingX: { xs: pxToRem(10), md: pxTovW(0) },
        paddingY: { xs: pxToRem(10), md: pxTovW(0) },
        border: { xs: '1px dashed lightgrey', md: 'unset' },
      }}
    >
      <Typography variant="h3" fontWeight="bold">
        Marking Scheme
      </Typography>

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: { xs: pxToRem(10), md: pxTovW(10) },
          marginTop: { xs: pxToRem(10), md: pxTovW(10) },
        }}
      >
        <IconWrapper
          name="check-blue"
          size="md"
          type="png"
          parentFolder="icons"
        />
        <Typography variant="h4">
          {markingScheme === MarkingSchemeEnum.MARKING_SCHEME_GENEO
            ? 'Geneo '
            : 'JEE '}
          Marking Scheme
        </Typography>
      </Box>
    </Box>
  );
};

// =====================================================
